// extracted by mini-css-extract-plugin
export default {"rightControlsStyle":"StaffReciepe_rightControlsStyle__UAtWv"};